import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ToastHandlerService} from '../../../shared/services/toast-handler.service';
import {TranslateService} from '@ngx-translate/core';
import {GeneralTerms, UserGeneralTermsApproval} from '../models/GeneralTerms';
import {User, USER_ROLE} from '../../../shared/models/user';
import {Router} from '@angular/router';

const LOCAL_STORAGE_KEY = 'lastRedirectToGeneralTerms';
const ONE_DAY_IN_SEC = 24 * 3600;

@Injectable({
  providedIn: 'root'
})
export class GeneralTermsService {

  constructor(private http: HttpClient,
              private toastService: ToastHandlerService,
              private translateService: TranslateService,
              private router: Router) { }

  public getUserLastTerms(): Promise<GeneralTerms> {
    return this.http.get(`${environment.backendUrl}general-terms/last`)
      .pipe(
        map((res: any) => res.data),
        catchError(err => {
          this.toastService.showErrorToasts(
            this.translateService.instant('client.modules.users.services.last_terms_error')
          );
          return throwError(err);
        })
      ).toPromise();
  }

  public getUserGeneralTermsHistory(): Promise<UserGeneralTermsApproval[]> {
    return this.http.get(`${environment.backendUrl}general-terms-history`)
      .pipe(
        map((res: any) => res.data),
        catchError(err => {
          this.toastService.showErrorToasts(
            this.translateService.instant('client.modules.users.services.last_terms_history_error')
          );
          return throwError(err);
        })
      ).toPromise();
  }

  public approvedGeneralTerms(generalTermsId: string): Promise<any> {
    return this.http.put(`${environment.backendUrl}general-terms/approve`, {
      generalTermsId
    })
      .pipe(
        map((res: any) => res),
        catchError(err => {
          this.toastService.showErrorToastsResponse(err);
          this.toastService.showErrorToasts(
            this.translateService.instant('client.modules.users.services.approved_general_terms_error')
          );
          return throwError(err);
        })
      ).toPromise();
  }

  public checkRedirectToGeneralTerms(user: User) {
    if ([USER_ROLE.CANDIDATE, USER_ROLE.VALET].includes(user.role)) {
      const lastRedirectToGeneralTerms = localStorage.getItem(LOCAL_STORAGE_KEY);
      const now = Math.floor(Date.now() / 1000);
      if (
        !user.approvedGeneralTerms &&
        (!lastRedirectToGeneralTerms || parseInt(lastRedirectToGeneralTerms, 10) + ONE_DAY_IN_SEC <= now)
      ) {
        localStorage.setItem(LOCAL_STORAGE_KEY, now.toString());
        this.router.navigate(['/', 'client', 'general-terms']);
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/', 'auth']);
      return false;
    }
  }
}
